import {LAYERS_ID} from './constants';
import {StartingLayer} from './startingLayer';

export class DestinationLayer extends StartingLayer {
    constructor() {
        super(LAYERS_ID.DESTINATION_INFORMO_LAYER);
    }
}



// WEBPACK FOOTER //
// ./src/app/cities/informo/layers/destinationLayer.ts